import { Divider, Skeleton } from "@mui/material";

interface Props {}

export default function NewOrderSkeletonUI(props: Props) {
	return (
		<div style={{ margin: "0 auto" }}>
			<div>
				<div style={{ margin: "20px 0px" }}>
					<Skeleton
						variant="rectangular"
						width={"35%"}
						height={40}
						sx={{ borderRadius: "4px" }}
					/>
				</div>
				<div
					style={{
						display: "flex",
						alignItems: "center",
						justifyContent: "space-between",
						gap: "10px",
					}}
				>
					<Skeleton
						variant="rectangular"
						width={"40%"}
						height={45}
						sx={{ borderRadius: "4px" }}
					/>
					<Skeleton
						variant="rectangular"
						width={"50%"}
						height={45}
						sx={{ borderRadius: "4px" }}
					/>
				</div>
				<Divider orientation="horizontal" flexItem sx={{ my: 2 }}></Divider>
				<div className="new-orders-button-panel">
					<div className="new-order-flexbutton-container">
						<div style={{ display: "inline-block", minWidth: "128px" }}>
							<Skeleton
								variant="rounded"
								width={"100%"}
								height={44}
								sx={{ borderRadius: "30px" }}
							></Skeleton>
						</div>
					</div>

					<div className="new-orders-button-sub-panel-right">
						<Skeleton
							variant="rounded"
							width={128}
							height={44}
							sx={{ borderRadius: "30px" }}
						></Skeleton>
						<div className="new-order-flexbutton-container">
							<div style={{ display: "inline-block", minWidth: "128px" }}>
								<Skeleton
									variant="rounded"
									width={"100%"}
									height={44}
									sx={{ borderRadius: "30px" }}
								></Skeleton>
							</div>
						</div>
					</div>
				</div>

				<Skeleton
					variant="rectangular"
					width={"100%"}
					height={90}
					sx={{ borderRadius: "14px", margin: "20px 0px" }}
				/>

				<Skeleton
					variant="rectangular"
					width={"100%"}
					height={90}
					sx={{ borderRadius: "14px", margin: "20px 0px" }}
				/>
			</div>
		</div>
	);
}
